/**
 * Open-state store for the keyboard-shortcuts help overlay.
 *
 * A tiny module singleton (mirrors the palette's open state in `commands.ts`)
 * so a registered command's `perform` can summon the sheet without
 * prop-drilling. React reads it through `useSyncExternalStore`
 * (see `hooks/useShortcutsHelp.ts`).
 */
type Listener = () => void;

const listeners = new Set<Listener>();
let open = false;

function emit(): void {
  for (const listener of listeners) listener();
}

export function isShortcutsHelpOpen(): boolean {
  return open;
}

export function setShortcutsHelpOpen(next: boolean): void {
  if (open === next) return;
  open = next;
  emit();
}

export function subscribeShortcutsHelp(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
